import { createContext } from 'react';
import { enUS } from 'date-fns/locale';
import { Observable } from 'rxjs';
import { type ApplicationContextState } from './ApplicationContext/store';
import { type UserContextState } from './UserContext/store';
import { type Organisation, type Period } from 'types/models';

export const ApplicationContext = createContext<Observable<ApplicationContextState>>(new Observable());
export const UserContext = createContext<Observable<UserContextState>>(new Observable());
export const OrganisationContext = createContext<Observable<Organisation>>(new Observable());
export const PeriodContext = createContext<Observable<Period | undefined>>(new Observable());
export const LocaleContext = createContext<typeof enUS | undefined>(enUS);
